var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-view',_vm._b({attrs:{"node":_vm.node}},'router-view',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }